"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/AppShell/AppShell.context.ts
const [AppShellProvider, useAppShellContext] = createSafeContext("AppShell was not found in tree");
//#endregion
export { AppShellProvider, useAppShellContext };

//# sourceMappingURL=AppShell.context.mjs.map